export default [
    {
        name: 'administracao-envio-sms',
        path: 'envio-sms',
        redirect: 'envio-sms/index',
        component: () => import(/* webpackChunkName: 'administracao-envio-sms' */ '@/views/administracao/envio-sms/Index'),
        children: [
            {
                meta: {title: 'Lista de SMS'},
                name: 'administracao-envio-sms-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-envio-sms' */ '@/views/administracao/envio-sms/List'),
            },
            {
                meta: {title: 'Nova mensagem'},
                name: 'administracao-envio-sms-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'administracao-envio-sms' */ '@/views/administracao/envio-sms/Form'),
            },
        ],
    },
]